import { ModuleBaseComponent } from '../components/module-base/module-base.component';

export type ModuleId = string;

export interface ModuleDef {
  id: ModuleId;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  load: () => Promise<typeof ModuleBaseComponent<any>>;
}

const MODULE_DEFINITIONS: ModuleDef[] = [
  {
    id: 'modules.hero-media-carousel',
    load: () =>
      import(
        'src/app/modules/components/hero-media-carousel/hero-media-carousel.component'
      ).then(mod => mod.HeroMediaCarouselComponent),
  },
  {
    id: 'modules.product-media-carousel',
    load: () =>
      import(
        'src/app/modules/components/product-media-carousel/product-media-carousel.component'
      ).then(mod => mod.ProductMediaCarouselComponent),
  },
  {
    id: 'modules.job-media-carousel',
    load: () =>
      import(
        'src/app/modules/components/job-media-carousel/job-media-carousel.component'
      ).then(mod => mod.JobMediaCarouselComponent),
  },
  {
    id: 'modules.copy-text',
    load: () =>
      import('src/app/modules/components/copy-text/copy-text.component').then(
        mod => mod.CopyTextComponent,
      ),
  },
  {
    id: 'modules.revealing-text',
    load: () =>
      import(
        'src/app/modules/components/revealing-text/revealing-text.component'
      ).then(mod => mod.RevealingTextComponent),
  },
  {
    id: 'modules.explainer-text',
    load: () =>
      import(
        'src/app/modules/components/explainer-text/explainer-text.component'
      ).then(mod => mod.ExplainerTextComponent),
  },
  {
    id: 'modules.innovation-section',
    load: () =>
      import(
        'src/app/modules/components/innovation-section/innovation-section.component'
      ).then(mod => mod.InnovationSectionComponent),
  },
  {
    id: 'modules.standard-media-carousel',
    load: () =>
      import(
        'src/app/modules/components/standard-media-carousel/standard-media-carousel.component'
      ).then(mod => mod.StandardMediaCarouselComponent),
  },
  {
    id: 'modules.simple-gallery',
    load: () =>
      import(
        'src/app/modules/components/simple-gallery/simple-gallery.component'
      ).then(mod => mod.SimpleGalleryComponent),
  },
  {
    id: 'modules.jump-marker',
    load: () =>
      import(
        'src/app/modules/components/jump-marker/jump-marker.component'
      ).then(mod => mod.JumpMarkerComponent),
  },
  {
    id: 'modules.toggle-list',
    load: () =>
      import(
        'src/app/modules/components/toggle-list/toggle-list.component'
      ).then(mod => mod.ToggleListComponent),
  },
  {
    id: 'modules.placeholder',
    load: () =>
      import(
        'src/app/modules/components/placeholder/placeholder.component'
      ).then(mod => mod.PlaceholderComponent),
  },
  {
    id: 'modules.featured-faq',
    load: () =>
      import(
        'src/app/modules/components/featured-faq/featured-faq.component'
      ).then(mod => mod.FeaturedFaqComponent),
  },
  {
    id: 'modules.system-media-carousel',
    load: () =>
      import(
        'src/app/modules/components/system-media-carousel/system-media-carousel.component'
      ).then(mod => mod.SystemMediaCarouselComponent),
  },
  {
    id: 'modules.faq',
    load: () =>
      import('src/app/modules/components/faq/faq.component').then(
        mod => mod.FAQComponent,
      ),
  },
  {
    id: 'modules.cta',
    load: () =>
      import('src/app/modules/components/cta/cta.component').then(
        mod => mod.CTAComponent,
      ),
  },
  {
    id: 'modules.navigation-gallery',
    load: () =>
      import(
        'src/app/modules/components/navigation-gallery/navigation-gallery.component'
      ).then(mod => mod.NavigationGalleryComponent),
  },
  {
    id: 'modules.contact-form',
    load: () =>
      import(
        'src/app/modules/components/contact-form/contact-form.component'
      ).then(mod => mod.ContactFormComponent),
  },
  {
    id: 'modules.single-image',
    load: () =>
      import(
        'src/app/modules/components/single-image/single-image.component'
      ).then(mod => mod.SingleImageComponent),
  },
  {
    id: 'modules.tech-facts',
    load: () =>
      import('src/app/modules/components/tech-facts/tech-facts.component').then(
        mod => mod.TechFactsComponent,
      ),
  },
  {
    id: 'modules.history-slider',
    load: () =>
      import(
        'src/app/modules/components/history-slider/history-slider.component'
      ).then(mod => mod.HistorySliderComponent),
  },
  {
    id: 'modules.product-archive',
    load: () =>
      import(
        'src/app/modules/components/reagents-archive/reagents-archive.component'
      ).then(mod => mod.ReagentsArchiveComponent),
  },
];

export const MODULE_DEFINITION_MAP = MODULE_DEFINITIONS.reduce(
  (map, moduleDef) => {
    map.set(moduleDef.id, moduleDef);
    return map;
  },
  new Map<ModuleId, ModuleDef>(),
);
